export const landingRoutes = [
  "/",
  "/testsAndInventories",
  "/pricing",
  "/aboutUs",
  "/individualServices",
  "/skillAnalytics",
  "/skillManagement",
  "/assessmentLibrary",
  "/contact",
  "/founders",
];

export const noMenuPatterns = ["invapp", "testapp", "application", "demography", "demoResult", "wrapup"];
